import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

interface Props {
  disabled?: boolean;
  isAdminGroup?: boolean;
  isOwner?: boolean;
  onConfirm: () => Promise<boolean> | undefined;
}

const RemoveAdminButton = ({
  disabled,
  isAdminGroup,
  isOwner,
  onConfirm
}: Props) => {
  const { messages } = useReduxState();

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonRemove}
      category="danger"
      confirmText={
        isOwner
          ? isAdminGroup
            ? messages.commonOwnerRemoveAdminGroupConfirm
            : messages.commonOwnerRemoveUserConfirm
          : isAdminGroup
          ? messages.commonAdminPermissionsRemoveAdminGroupConfirm
          : messages.commonAdminPermissionsRemoveUserConfirm
      }
      confirmTitle={
        isOwner
          ? messages.commonOwnerRemove
          : messages.commonAdminPermissionsRemove
      }
      disabled={disabled}
      onConfirm={onConfirm}
      successMessage={
        isOwner
          ? messages.commonOwnerRemoveSuccess
          : messages.commonAdminPermissionsRemovSuccess
      }
    />
  );
};

export default RemoveAdminButton;
